import { render, staticRenderFns } from "./ResponsiveImage.vue?vue&type=template&id=ff831a06&scoped=true&"
import script from "./ResponsiveImage.vue?vue&type=script&lang=js&"
export * from "./ResponsiveImage.vue?vue&type=script&lang=js&"
import style0 from "./ResponsiveImage.vue?vue&type=style&index=0&id=ff831a06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff831a06",
  null
  
)

export default component.exports